import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EmailIcon from '@mui/icons-material/Email';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import Colors from '../colors';
import InfoRow from './InfoRow';
import ConfirmationModal from './modals/ConfirmationModal';

function ToggleAdmins({ user, updateAdmins, deleteAdmins }) {
  const accordionStyle = {
    borderRadius: '20px',
    border: `1px solid ${Colors.blue}`,
    boxShadow: '0px 3px 11px rgba(45, 156, 219, 0.5)',
    width: '500px',
    maxWidth: '100%',
    overflow: 'hidden',
  }

  const accordionSummaryStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }

  const nameStyle = {
    margin: 'auto',
    paddingRight: 10,
    fontWeight: '400',
    fontSize: '19px'
  }
  const emailStyle = { width: '33px', height: '33px', color: Colors.green, marginRight: '20px' }
  const adminStyle = { width: '33px', height: '33px', color: Colors.blue, marginRight: '20px' }
  const [isChecked, setIsChecked] = useState(user.isAdmin);
  const [isVisible, setIsVisible] = useState(false)
  const [text, setText] = useState('')
  useEffect(() => {
    if (user.isAdmin) {
      setText('Revoke Admin Access')
    } else {
      setText('Grant Admin Access')
    }
  }, [user])

  const updatePermission = async () => {
    const newUser = { ...user, isAdmin: !user.isAdmin };
    setIsChecked(newUser.isAdmin);
    await updateAdmins(newUser);
    await deleteAdmins(newUser);
    setIsVisible(false);
  };

  const handleChange = async () => {
    setIsVisible(true)
  };


  return (
    <div style={{ maxWidth: '100%' }}>
      <Accordion style={accordionStyle}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={accordionSummaryStyles}>
          <PersonIcon style={{ color: Colors.blue, width: '38px', height: '38px' }} />
          <span style={nameStyle}>{`${user.first_name} ${user.last_name}`}</span>
        </AccordionSummary>
        <Divider />
        <AccordionDetails style={{ padding: 0 }}>
          <div>
            <InfoRow iconComponent={<EmailIcon style={emailStyle} />} title={"Email"} mainText={user.email}></InfoRow>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <InfoRow
                iconComponent={<AdminPanelSettingsIcon style={adminStyle} />}
                title="Update User Permissions"
                mainText={text}
              />
              <Switch
                checked={isChecked}
                onChange={handleChange}
                color="primary"
              />
            </div>

          </div>
        </AccordionDetails>
      </Accordion>
      {isVisible && <ConfirmationModal
        mainAction={"Yes"}
        title={`Do you want to ${text}?`}
        setIsVisible={setIsVisible}
        isVisible={isVisible}
        mainActionHandler={updatePermission}
        color={Colors.green}
      />}
    </div>
  )
}

export default ToggleAdmins;